import * as React from 'react';

const Page404: React.FC = (props: object) => {
  return <h1>Page not found</h1>;
};

export default Page404;
